import { useState, useEffect } from "react";
import { loadVendorEnquiryList, loadVendorQuotationList } from "../services/vendorEnquiryService";

const useVendorQuotationList = (Mode) => {
    const [vendorQuotationList, setVendorQuotationList] = useState([]);
    const [selectPurchasedIndent, setSelectPurchasedIndent] = useState(null);
    const [selectPurchasedIndentID, setSelectPurchasedIndentID] = useState(null);
    const [isVendorQuotationDataLoaded, setIsVendorQuotationDataLoaded] = useState(false);

    // Fetch department data
    const fetchVendorQuotation = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid"), p_plantid: 1 };

        try {
            const data = await loadVendorQuotationList(para);
            if (data && data.length > 0) {
                setVendorQuotationList(data);
                setIsVendorQuotationDataLoaded(true);
            }
            else {
                setVendorQuotationList([]);
                setIsVendorQuotationDataLoaded(false);
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isVendorQuotationDataLoaded) {
            fetchVendorQuotation();
        }
    }, [isVendorQuotationDataLoaded]);

    // Function to load department based on selected ID
    const loadVendorQuotationByID = async (selectedID) => {
        await fetchVendorQuotation(selectedID);
    };

    return {
        vendorQuotationList,
        setVendorQuotationList,
        selectPurchasedIndent,
        selectPurchasedIndentID,
        loadVendorQuotationByID,
    };
};

export default useVendorQuotationList;
